// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen.js";
import infiniteScroll from "./infiniteScroll.js";
import glow from "./glow.js";


// Call the menu, infinite scroll and background-glow functions
menuOpen();
infiniteScroll();
glow();
